// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticker-container {
  display: flex;
  align-items: center;
  width: 100%;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  padding: 10px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Left Label */
.ticker-label {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(6px);
  color: #050505;
  font-weight: 700;
  padding: 8px 16px;
  margin-left: 10px;
  border-radius: 20px;
  white-space: nowrap;
  font-size: 14px;
}

/* Scrolling Area */
.ticker {
  overflow: hidden;
  flex: 1 1;
  margin-left: 15px;
}

.ticker-track {
  display: inline-flex;
  white-space: nowrap;
  animation: scroll 18s linear infinite;
}

.ticker-track span {
  color: #040404;
  font-size: 14px;
  padding-right: 80px;
  letter-spacing: 0.5px;
  font-weight: bold;
}

/* Animation */
@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Pause on hover */
.ticker:hover .ticker-track {
  animation-play-state: paused;
}

/* Mobile Responsive */
@media (max-width: 600px) {
  .ticker-container {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
  }

  .ticker-label {
    margin-bottom: 5px;
    font-size: 12px;
  }

  .ticker-track span {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewsTicker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".ticker-container {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  background: linear-gradient(90deg, #ff7e5f, #feb47b);\r\n  padding: 10px 0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Left Label */\r\n.ticker-label {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(6px);\r\n  color: #050505;\r\n  font-weight: 700;\r\n  padding: 8px 16px;\r\n  margin-left: 10px;\r\n  border-radius: 20px;\r\n  white-space: nowrap;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Scrolling Area */\r\n.ticker {\r\n  overflow: hidden;\r\n  flex: 1;\r\n  margin-left: 15px;\r\n}\r\n\r\n.ticker-track {\r\n  display: inline-flex;\r\n  white-space: nowrap;\r\n  animation: scroll 18s linear infinite;\r\n}\r\n\r\n.ticker-track span {\r\n  color: #040404;\r\n  font-size: 14px;\r\n  padding-right: 80px;\r\n  letter-spacing: 0.5px;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Animation */\r\n@keyframes scroll {\r\n  0% {\r\n    transform: translateX(0%);\r\n  }\r\n  100% {\r\n    transform: translateX(-50%);\r\n  }\r\n}\r\n\r\n/* Pause on hover */\r\n.ticker:hover .ticker-track {\r\n  animation-play-state: paused;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 600px) {\r\n  .ticker-container {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    padding: 8px;\r\n  }\r\n\r\n  .ticker-label {\r\n    margin-bottom: 5px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .ticker-track span {\r\n    font-size: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
